module.exports = "<div mat-dialog-content>\r\n  <h1 [innerHtml]=\"title\"></h1>\r\n  <p [innerHtml]=\"message\"></p>\r\n</div>\r\n<button (click)=\"closeModal()\" mat-button class=\"main-button\">{{buttonText}}</button>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/uriel/Documents/newspaperReporteador/src/app/components/message-dialog/message-dialog.component.html
// module id = ../../../../../src/app/components/message-dialog/message-dialog.component.html
// module chunks = main